module.exports = __webpack_public_path__ + "img/weeklyReport_01.ec45378b.png";